import { useContext } from "react";
import { EntryContext } from "../contexts/EntryContext";

export function useEntrys() {
  const context = useContext(EntryContext);

  return context;
}
